import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { getIsDraft, getHasChangesRequested } from 'quotes-ui-lib/utils/status';
import { jsx as _jsx } from "react/jsx-runtime";
const EditButton = ({
  onClick
}) => {
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "edit-quote-btn",
    "data-selenium-test": "edit-quote-btn",
    use: "tertiary-light",
    responsive: false,
    size: "extra-small",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.edit.buttonText"
    })
  }, "edit-button");
};
export default EditButton;
export const showEditButton = (quote, canCurrentUserEditQuote) => {
  const isEditable = getIsDraft(quote) || getHasChangesRequested(quote);
  return isEditable && canCurrentUserEditQuote;
};